(function () {
  document.querySelectorAll('[data-routed-collection]').forEach(initCollection);

  function initCollection(collection) {
    const drawer = collection.querySelector('[data-drawer]');
    const form = collection.querySelector('[data-drawer-form]');
    const openButtons = collection.querySelectorAll('[data-drawer-open]');
    const closeButtons = collection.querySelectorAll('[data-drawer-close]');
    const sortSelect = collection.querySelector('[data-drawer-sort]');

    if (!drawer || !form) return;

    function openDrawer(focusSection) {
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      // Force reflow so transition fires
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';

      if (focusSection) {
        const target = drawer.querySelector(`[data-drawer-section="${focusSection}"]`);
        if (target) {
          setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
        }
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => {
        drawer.hidden = true;
        drawer.setAttribute('aria-hidden', 'true');
      }, 350);
    }

    openButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const focus = btn.dataset.drawerFocus;
        openDrawer(focus);
      });
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // ----- Form submission — build URL with filter params -----
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      submitFilters();
    });

    // Sort dropdown auto-submits
    if (sortSelect) {
      sortSelect.addEventListener('change', submitFilters);
    }

    function submitFilters() {
      const formData = new FormData(form);
      const params = new URLSearchParams();

      // Group multi-select filters properly
      formData.forEach((value, key) => {
        if (value !== '' && value != null) {
          params.append(key, value);
        }
      });

      const baseUrl = window.location.pathname;
      const queryString = params.toString();
      window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    }

    // Update active state visually when checkboxes toggle (before submit)
    form.addEventListener('change', (e) => {
      const input = e.target;
      if (input.type === 'checkbox') {
        const option = input.closest('.routed-drawer__option');
        if (option) {
          option.classList.toggle('is-active', input.checked);
        }
      }
    });
  }
})();
/* ============================================================
   PRODUCT CARD — Color swatch image swap
   ============================================================ */

(function () {
  document.querySelectorAll('.routed-card').forEach(initCard);

  function initCard(card) {
    const swatches = card.querySelectorAll('[data-color-name]');
    const primaryImg = card.querySelector('[data-primary-image]');
    const nameDisplay = card.querySelector('[data-color-name-display]');

    if (swatches.length === 0 || !primaryImg) return;

    // Cache the original image URL so we can restore if needed
    const originalSrc = primaryImg.getAttribute('src');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const colorName = swatch.dataset.colorName;
        const colorImage = swatch.dataset.colorImage;

        // Update active state
        swatches.forEach((s) => s.classList.remove('is-active'));
        swatch.classList.add('is-active');

        // Update color name display
        if (nameDisplay) {
          nameDisplay.textContent = colorName;
        }

        // Swap image if a variant image exists
        if (colorImage && colorImage.trim() !== '') {
          primaryImg.setAttribute('src', colorImage);
        }
      });

      // Don't let swatch click navigate when nested inside link
      swatch.addEventListener('mousedown', (e) => e.stopPropagation());
    });
  }
})();